document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-mobile-menu]');
  const open = document.querySelector('[data-menu-open]');
  const close = document.querySelector('[data-menu-close]');

  const setMenu = (visible) => {
    if (!menu) return;
    menu.hidden = !visible;
    document.body.classList.toggle('menu-open', visible);
    if (visible) menu.querySelector('button, a')?.focus();
  };

  open?.addEventListener('click', () => setMenu(true));
  close?.addEventListener('click', () => setMenu(false));
  menu?.addEventListener('click', (event) => {
    if (event.target === menu) setMenu(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });
});
